import React from 'react'

import { Box, Input, MenuItem, MenuList, Popover } from '@mui/material'

type AutoCompletePopupProps = {
  open: boolean
  options: any
  selected: any
  onChange: (...args: any[]) => any
  onClose: (...args: any[]) => any
  onFilterChange: (...args: any[]) => any
  filter?: string
}

const anchorOrigin = { vertical: 'top', horizontal: 'center' } as const
const transformOrigin = { vertical: 'top', horizontal: 'center' } as const

// Cap the rendered list so an empty search still shows results without dumping thousands of nodes.
const MAX_RESULTS = 150

const AutoCompletePopup = ({
  open,
  options,
  selected,
  onChange,
  onClose,
  onFilterChange,
  filter,
}: AutoCompletePopupProps) => {
  const handleToggle = (e: any) => onChange(e.currentTarget.getAttribute('value'))

  const renderOptions = () => {
    const matched = filter
      ? options.filter(({ label }: any) => label.toLowerCase().includes(filter.toLowerCase()))
      : options
    const visibleOptions = matched.slice(0, MAX_RESULTS)

    // MUI v9 MenuItem needs a MenuList ancestor.
    return (
      <MenuList>
        {visibleOptions.map(({ value, label }: any) => (
          <MenuItem key={value} onClick={handleToggle} selected={selected.includes(value)} value={value}>
            {label}
          </MenuItem>
        ))}
      </MenuList>
    )
  }

  return (
    <Popover anchorOrigin={anchorOrigin} onClose={onClose} open={open} transformOrigin={transformOrigin}>
      <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 400 }}>
        <Box sx={{ p: '16px' }}>
          <Input autoFocus fullWidth onChange={onFilterChange} placeholder="Search..." value={filter} />
        </Box>
        <Box sx={{ height: '100%', overflow: 'auto' }}>{renderOptions()}</Box>
      </Box>
    </Popover>
  )
}

export default AutoCompletePopup
